export const evaluationStepsByLevel = [8, 5, 2, 4, 5];
export const evaluationSwitchStepByLevel = [0, 3, 8, 10, 14, 17];

export function getLevelBasedOnEvaluationStep(evaluationStep: number) {
  if (evaluationStep <= 3) {
    return 1;
  }
  if (evaluationStep <= 8) {
    return 1;
  }
  if (evaluationStep <= 10) {
    return 3;
  }
  if (evaluationStep <= 14) {
    return 4;
  }
  return 5;
}
export function getLevelAndProgressForEvaluation(evaluationStep: number) {
  const level = getLevelBasedOnEvaluationStep(evaluationStep);
  const min = evaluationSwitchStepByLevel[level - 1]
  const max = evaluationStepsByLevel[level - 1]
  const currentStepForLevel = evaluationStep - min;
  return {
    level: levels.find(({value}) => value === level)!.name,
    progress: `${currentStepForLevel}/${max}`
  };
}

// Should be linked to backend
export const levels = [
  {
    value: 1,
    name: "Novice",
    catalog_difficulty: 1
  },
  // Temporary disabled while starting to integrate the skill model

  // {
  //   value: 2,
  //   name: "Novice II",
  //   catalog_difficulty: 1
  // },
  {
    value: 3,
    name: "Débutant",
    catalog_difficulty: 2
  },
  //   {
  //   value: 3,
  //   name: "Débutant I",
  //   catalog_difficulty: 2
  // },
  // {
  //   value: 4,
  //   name: "Débutant II",
  //   catalog_difficulty: 2
  // },
  {
    value: 5,
    name: "Intermédiaire",
    catalog_difficulty: 3
  },
  {
    value: 6,
    name: "Avancé",
    catalog_difficulty: 4
  }
]

